import { InjectedConnector } from '@web3-react/injected-connector'
import { ConnectorNames } from 'constants/types'
import Web3 from 'web3'
import { walletConnectConnector } from './walletConnectConnector'

const injected = new InjectedConnector({})

export const connectorsByName: { [connectorName in ConnectorNames]: any } = {
  [ConnectorNames.Injected]: injected,
  [ConnectorNames.WalletConnect]: walletConnectConnector,
}

export const getLibrary = (provider): Web3 => {
  return provider
}
